module.exports = __webpack_public_path__ + "img/Hair-Clip_fr.678a770f.jpg";